(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aniarcs-black-clover"] && !Shopify.designMode) return;
  try {
    
function updateBlackCloverRelease() {
  document.querySelectorAll('[data-bc-release-label]').forEach(label => {
    const premiere = new Date('2026-10-03T23:00:00+09:00').getTime();
    const remaining = premiere - Date.now();
    if (remaining <= 0) label.textContent = 'THE NEW CHAPTER HAS BEGUN / 2ND SEASON';
    else if (remaining < 86400000) label.textContent = 'THE RETURN IS NEAR / 3 OCTOBER 2026';
    else label.textContent = 'THE NEXT CHAPTER / 3 OCTOBER 2026';
  });
}
updateBlackCloverRelease();
document.addEventListener('shopify:section:load', updateBlackCloverRelease);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aniarcs-cart-upsell"]) return;
  try {
    
if(!customElements.get('aniarcs-cart-offer'))customElements.define('aniarcs-cart-offer',class extends HTMLElement{
 connectedCallback(){
  if(this.started)return;this.started=true;
  this.catalog=JSON.parse(this.querySelector('[data-catalog]').textContent).filter(p=>p&&p.variants.some(v=>v.available));
  this.select=this.querySelector('[data-product]');this.button=this.querySelector('[data-add-button]');this.error=this.querySelector('[data-error]');
  this.money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'GBP'});
  this.catalog.forEach(p=>{const o=document.createElement('option');o.value=p.id;o.textContent=p.title;this.select.append(o)});
  this.select.addEventListener('change',()=>this.chooseProduct());
  this.button.addEventListener('click',()=>this.add());
  this.chooseProduct();this.refresh();this.timer=setInterval(()=>{if(!document.hidden&&!this.busy)this.refresh()},3000);
 }
 disconnectedCallback(){clearInterval(this.timer);this.started=false}
 chooseProduct(){this.product=this.catalog.find(p=>String(p.id)===this.select.value);if(!this.product)return;this.variant=this.product.variants.find(v=>v.available);this.renderOptions();this.render()}
 renderOptions(){
  const root=this.querySelector('[data-options]');root.replaceChildren();
  const img=this.querySelector('[data-image]');img.src=this.variant.featured_image?.src||this.product.image;img.alt=this.product.title;
  this.product.options.forEach((name,i)=>{const group=document.createElement('fieldset'),legend=document.createElement('legend');legend.textContent=name;group.append(legend);
   [...new Set(this.product.variants.map(v=>v.options[i]))].forEach(value=>{const b=document.createElement('button');b.type='button';b.textContent=value;b.setAttribute('aria-pressed',String(this.variant.options[i]===value));const options=[...this.variant.options];options[i]=value;const next=this.product.variants.find(v=>v.available&&v.options.every((o,j)=>o===options[j]));b.disabled=!next;b.addEventListener('click',()=>{this.variant=next;this.renderOptions();this.render()});group.append(b)});root.append(group);
  });
 }
 async refresh(){
  if(this.reading)return;this.reading=true;
  try{const response=await fetch(this.dataset.cart+'.js',{cache:'no-store'});if(!response.ok)throw Error();this.cart=await response.json();this.render()}catch{this.hidden=true}finally{this.reading=false}
 }
 render(){
  if(!this.cart||!this.variant)return;
  const ids=new Set(this.catalog.map(p=>p.id));this.lines=this.cart.items.filter(i=>ids.has(i.product_id));this.count=this.lines.reduce((n,i)=>n+i.quantity,0);
  this.hidden=this.count<1||this.count>2;if(this.hidden)return;
  const percentage=this.count===1?10:15,discounted=price=>price-Math.floor(price*percentage/100);
  const total=this.lines.reduce((n,i)=>n+discounted(i.original_price)*i.quantity,0)+discounted(this.variant.price);
  const previous=this.lines.reduce((n,i)=>n+i.final_line_price,0),extra=total-previous;
  this.querySelector('[data-heading]').textContent=this.count===1?'Complete your duo.':'Complete your trio.';
  this.querySelector('[data-price]').textContent='Add one for '+this.money.format(extra/100)+' more. Jersey '+(this.count===1?'pair':'trio')+': '+this.money.format(total/100)+'.';
 }
 async add(){
  if(this.busy)return;this.busy=true;this.button.disabled=true;this.error.hidden=true;
  try{
   await this.refresh();if(this.hidden)throw Error('Your basket changed. Please review your items.');
   const response=await fetch(this.dataset.add,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:1}]})});
   const result=await response.json();if(!response.ok)throw Error(result.description||'Could not add this jersey. Please try again.');
   location.assign(this.dataset.cart);
  }catch(e){this.error.textContent=e.message||'Please check your connection and try again.';this.error.hidden=false;this.busy=false;this.button.disabled=false}
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aniarcs-product"]) return;
  try {
    

document.querySelectorAll('[data-aniarcs-product]').forEach(section=>{
 if(section.dataset.ready)return;
 section.dataset.ready='true';
 const form=section.querySelector('form');
 const variant=section.querySelector('[data-aniarcs-variant]');
 if(!variant)return;
 const quantity=section.querySelector('[data-aniarcs-quantity]');
 const headline=section.querySelector('.aniarcs-product__price');
 const submit=form.querySelector('[type="submit"]');
 const error=form.querySelector('[data-cart-error]');
 const deals=[...section.querySelectorAll('[data-deal-quantity]')];
 const players=[...section.querySelectorAll('[data-character-choice]')];
 const sizes=[...section.querySelectorAll('[data-size-choice]')];
 const slots=[...section.querySelectorAll('[data-bundle-slot]')];
 const catalog=JSON.parse(section.querySelector('[data-bundle-catalog]').textContent).filter(Boolean);
 const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:section.dataset.currency||'GBP'});
 const parts=option=>JSON.parse(option.dataset.options);
 const current=()=>variant.selectedOptions[0];
 const currentSize=()=>parts(current()).find(p=>sizes.some(b=>b.dataset.sizeChoice===p));
 const currentPlayer=()=>parts(current()).find(p=>players.some(b=>b.dataset.characterChoice===p));
 const count=()=>Number(deals.find(d=>d.checked)?.dataset.dealQuantity||1);
 const selections={};
 const alert=message=>{error.textContent=message;error.hidden=!message;};
 const selectedVariant=slot=>{const state=selections[slot];return state?.product.variants.find(v=>v.options.every((o,i)=>o===state.options[i]));};
 function renderSlot(slot){
  const key=slot.dataset.bundleSlot;
  if(!selections[key]){
   const product=catalog.find(p=>p.variants.some(v=>String(v.id)===variant.value))||catalog[0];
   if(!product)return;
   const v=product.variants.find(v=>v.available)||product.variants[0];
   selections[key]={product,options:[...v.options]};
  }
  const state=selections[key], root=slot.querySelector('[data-bundle-controls]');
  root.replaceChildren();
  const label=document.createElement('label');label.textContent='Jersey';
  const select=document.createElement('select');select.setAttribute('aria-label','Jersey '+key+' product');
  catalog.forEach(p=>{const o=document.createElement('option');o.value=p.id;o.textContent=p.title;o.selected=p.id===state.product.id;select.append(o);});
  select.addEventListener('change',()=>{
   const product=catalog.find(p=>String(p.id)===select.value);
   const v=product.variants.find(v=>v.available)||product.variants[0];
   selections[key]={product,options:[...v.options]};renderSlot(slot);sync();
  });label.append(select);root.append(label);
  state.product.options.forEach((name,index)=>{
   const group=document.createElement('fieldset');const legend=document.createElement('legend');legend.textContent=name;group.append(legend);
   [...new Set(state.product.variants.map(v=>v.options[index]))].forEach(value=>{
    const button=document.createElement('button');button.type='button';button.textContent=value;
    button.setAttribute('aria-pressed',String(state.options[index]===value));
    const proposed=[...state.options];proposed[index]=value;
    button.disabled=!state.product.variants.some(v=>v.available&&v.options.every((o,i)=>o===proposed[i]));
    button.addEventListener('click',()=>{state.options=proposed;renderSlot(slot);sync();});group.append(button);
   });root.append(group);
  });
 }
 function sync(){
  const n=count();
  const picker=section.querySelector('[data-aniarcs-bundle-picker]');
  if(picker)picker.hidden=n===1;
  slots.forEach(slot=>{slot.hidden=Number(slot.dataset.bundleSlot)>n;if(!slot.hidden&&!selections[slot.dataset.bundleSlot])renderSlot(slot);});
  const accelerated=form.querySelector('.shopify-payment-button');if(accelerated)accelerated.hidden=n>1;
  quantity.value=n>1?n:quantity.value;
  quantity.readOnly=n>1;
  deals.forEach(deal=>{
   const amount=Number(deal.dataset.dealQuantity);
   const discountPercent=Math.round(Number(deal.dataset.dealDiscount)*100);
   const discountedPrice=price=>price-Math.floor(price*discountPercent/100);
   let total=discountedPrice(Number(current().dataset.price));
   for(let slot=2;slot<=amount;slot++)total+=discountedPrice(selectedVariant(String(slot))?.price??Number(current().dataset.price));
   section.querySelector('label[for="'+deal.id+'"] [data-deal-price]').textContent=money.format(total/100);
   if(deal.checked)headline.textContent=money.format(total/100);
  });
  if(!deals.length)headline.textContent=money.format(Number(current().dataset.price)/100);
  const player=currentPlayer()?.toLowerCase();
  const frames=[...section.querySelectorAll('[data-aniarcs-media]')];
  frames.forEach(frame=>{
   const tag=(frame.dataset.character||'').trim().toLowerCase();
   frame.hidden=false;
  });
  players.forEach(b=>{const chosen=b.dataset.characterChoice===currentPlayer();b.classList.toggle('is-selected',chosen);b.setAttribute('aria-pressed',String(chosen));});
  sizes.forEach(b=>{const chosen=b.dataset.sizeChoice===currentSize();b.classList.toggle('is-selected',chosen);b.setAttribute('aria-pressed',String(chosen));});
  submit.disabled=current().disabled;
 }
 function choose(player,size){
  const next=[...variant.options].find(o=>!o.disabled&&parts(o).includes(size)&&(!players.length||parts(o).includes(player)));
  if(!next){alert('This player and size combination is unavailable. Please choose another.');return;}
  alert('');variant.value=next.value;sync();
 }
 players.forEach(b=>b.addEventListener('click',()=>choose(b.dataset.characterChoice,currentSize())));
 sizes.forEach(b=>b.addEventListener('click',()=>choose(currentPlayer(),b.dataset.sizeChoice)));
 variant.addEventListener('change',sync);
 deals.forEach(d=>d.addEventListener('change',()=>{quantity.value=count();sync();}));
 let pending=false;
 form.addEventListener('submit',async event=>{
  event.preventDefault();
  if(pending)return;
  alert('');
  if(!form.reportValidity())return;
  const n=count(),items=[{id:variant.value,quantity:n>1?1:Number(quantity.value)}];
  for(let slot=2;slot<=n;slot++){
   const v=selectedVariant(String(slot));
   if(!v?.available){alert('Choose an available jersey, player and size for item '+slot+'.');return;}
   items.push({id:String(v.id),quantity:1});
  }
  pending=true;submit.disabled=true;submit.setAttribute('aria-busy','true');
  try{
   const response=await fetch(section.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
   const result=await response.json();
   if(!response.ok)throw new Error(result.description||result.message||'Your items could not be added. Please try again.');
   window.location.assign(section.dataset.cartUrl);
  }catch(e){alert(e.message||'Connection problem. Please try again.');pending=false;submit.disabled=false;submit.removeAttribute('aria-busy');}
 });
 const sticky=document.querySelector('[data-aniarcs-sticky-submit]');
 if(sticky)sticky.addEventListener('click',()=>form.requestSubmit());
 sync();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
